import { render, staticRenderFns } from "./PopupDashAdmin.vue?vue&type=template&id=5edf4012&scoped=true"
import script from "./PopupDashAdmin.vue?vue&type=script&lang=js"
export * from "./PopupDashAdmin.vue?vue&type=script&lang=js"
import style0 from "./PopupDashAdmin.vue?vue&type=style&index=0&id=5edf4012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf4012",
  null
  
)

export default component.exports